import styled from 'styled-components'
import { Menu, Reply } from '@styled-icons/material-outlined'
import { Person } from '@styled-icons/material'
import { useLocation, useHistory, Link } from 'react-router-dom'
import { FormsAppLogo } from 'components/FormsAppLogo'
import MaintenanceInfobox from 'components/MaintenanceInfobox'
import MenuToggle from 'components/Menu/MenuToggle'
import Masthead from './Masthead'

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  gap: 1rem;
  background-color: ${({ theme }) => theme.palette.nswPaletteWhite};
  border-bottom: 1px solid ${({ theme }) => theme.palette.nswPaletteGrey04};
`
HeaderContainer.displayName = 'HeaderContainer'

const MainHeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
`
HeaderContainer.displayName = 'HeaderContainer'

const IconContainer = styled.div`
  display: flex;
  align-items: center;
`
const HeaderLogoContainer = styled.div`
  display: block;
  background-color: ${({ theme }) => theme.palette.nswPaletteWhite};
  @media screen and (${({ theme }) => theme.breakPoints.tablet}) {
    position: absolute;
    left: 43%;
  }
`
HeaderLogoContainer.displayName = 'HeaderLogoContainer'

IconContainer.displayName = 'IconContainer'

const baseIconStyle = `
  height: 2rem;
  color: var(--nsw-brand-dark);
  align-self: center;
`

const BackIcon = styled(Reply)<{ $visible: boolean }>`
  ${baseIconStyle}
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
  cursor: pointer;
`
BackIcon.displayName = 'BackIcon'

const ProfileLink = styled(Link)``
ProfileLink.displayName = 'ProfileLink'

const ProfileIcon = styled(Person)<{ $visible: boolean }>`
  ${baseIconStyle}
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
  cursor: pointer;
`
ProfileIcon.displayName = 'ProfileIcon'

const PrimaryDescriptor = styled.div`
  font-weight: 700;
  font-size: ${({ theme }) => theme.font.heading};
`

const SecondaryDescriptor = styled.div`
  font-size: calc(${({ theme }) => theme.font.heading} * 0.7);
`
const DescriptorContainer = styled.div`
  display: none;
  align-self: center;
  color: ${({ theme }) => theme.palette.nswBrandDark};
  line-height: 1.75rem;

  @media screen and (${({ theme }) => theme.breakPoints.tablet}) {
    display: block;
    align-self: flex-start;
  }
`
DescriptorContainer.displayName = 'DescriptorContainer'

const MenuText = styled.div`
  font-size: var(--nsw-font-size-xxs-mobile);
  flex: 0 0 auto;
`
const HamburgerContainer = styled.div`
  display: flex;
  align-items: start;
  flex-direction: column;
  font-weight: var(--nsw-font-bold);
  border-radius: var(--nsw-border-radius);
  color: var(--nsw-brand-dark);
  cursor: pointer;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
`
HamburgerContainer.displayName = 'HamburgerContainer'

const HamburgerMenuContent = styled.div`
  right: 0;
  z-index: 3;
  padding: 16px 16px;
  background-color: ${({ theme }) => theme.palette.nswPaletteOffWhite};
  box-shadow: rgb(0 0 0 / 20%) 0px 1px 5px 0px, rgb(0 0 0 / 14%) 0px 2px 2px 0px,
    rgb(0 0 0 / 12%) 0px 3px 1px -2px;
`
HamburgerMenuContent.displayName = 'HamburgerMenuContent'

const HamburgerIcon = styled(Menu)`
  ${baseIconStyle}
  flex: 0 0 auto;
  color: ${({ theme }) => theme.palette.nswBrandDark};
`
HamburgerIcon.displayName = 'HamburgerIcon'

const ActionsContainer = styled.div`
  display: flex;
  gap: 1rem;
`
const HamburgerHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
`

export default function Header() {
  const location = useLocation()
  const history = useHistory()
  const descriptors = {
    primary: 'Department of Primary Industries',
    secondary: 'Department of Regional NSW',
  }

  return (
    <>
      <MaintenanceInfobox />
      <Masthead />
      <HeaderContainer className="fa-header">
        <MainHeaderContent>
          <HamburgerHeaderContainer>
            <HamburgerContainer>
              <MenuToggle />
              <MenuText>Menu</MenuText>
            </HamburgerContainer>
            <HeaderLogoContainer>
              <FormsAppLogo descriptors={descriptors} />
            </HeaderLogoContainer>
          </HamburgerHeaderContainer>
          <ActionsContainer>
            <BackIcon
              className="fa-header__back-button"
              $visible={
                !(location.pathname === '/' || location.pathname === '/login')
              }
              onClick={() => history.goBack()}
            />
            <ProfileLink to="/profile" className="fa-header__profile-button">
              <ProfileIcon $visible={location.pathname !== '/login'} />
            </ProfileLink>
          </ActionsContainer>
        </MainHeaderContent>
        <DescriptorContainer>
          <PrimaryDescriptor>{descriptors.primary}</PrimaryDescriptor>
          {descriptors.primary && (
            <SecondaryDescriptor>{descriptors.secondary}</SecondaryDescriptor>
          )}
        </DescriptorContainer>
      </HeaderContainer>
    </>
  )
}
